/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TransferCharge/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import FromReceivableLink from './FromReceivableLink/index'
import LedgerPaymentAccount from 'DesignSystem/LedgerPaymentAccount/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import ToReceivableLink from './ToReceivableLink/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import Tysiav2PaymentTransferIcon from 'DesignSystem/Svgs/Tysiav2PaymentTransferIcon/index'
import Tysiav2PlusIcon from 'DesignSystem/Svgs/Tysiav2PlusIcon/index'
import Tysiav2ReturnIcon from 'DesignSystem/Svgs/Tysiav2ReturnIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TransferCharge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/TransferCharge"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.900'
        })
let entryTransactionAmountValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.amount',
format: fromFormat.numberMoney,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivableValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable',
format: fromHelpers.getText,
})
let entryTransactionReceivableValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.receivable',
format: fromHelpers.getText,
})
let constantData = 'on '
let entryCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_at',
format: fromFormat.dateShortWithMonthAndTime,
})
let constantData1 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, entryCreatedAtValueData, constantData1)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let entryTransactionReceivablePaymentAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'transaction.receivable.payment_account.id',
})
let entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivablePaymentAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable.payment_account.id',
})
let aggregateData1 = fromAggregate.equals(entryTransactionReceivablePaymentAccountIdValueData, entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivablePaymentAccountIdValueData)
let entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivablePaymentAccountValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable.payment_account',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="TransferCharge.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TransferCharge.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-cMlrT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-cMlrT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-cMlrT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-cMlrT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-cMlrT': dtColorsGreen200,'--mt-6-cMlrT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2PlusIcon
  viewPath={`${viewPath}/Tysiav2PlusIcon`}
 fill2={dtColorsGreen900}
 width={6}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 data="entry.transaction.amount"
 format="/Data/format.js numberMoney"
 text={entryTransactionAmountValueData}
/>
<div
  data-testid="TransferCharge.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-7-cMlrT': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-8-cMlrT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="TransferCharge.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-8-cMlrT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="blue"
 style="filled"
 marginTop={dtSpaceXxxs}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2PaymentTransferIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2PaymentTransferIcon`}
 fill={dtColorsBlue900}
 stroke={dtColorsBlue200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Transfer Debt"
/>
</React.Fragment>
)}
</TysiaTag>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="moved in from"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable"
 format="helpers.js getText"
 text={entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivableValueData}
/>
<FromReceivableLink
  viewPath={`${viewPath}/FromReceivableLink`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="to"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.transaction.receivable"
 format="helpers.js getText"
 text={entryTransactionReceivableValueData}
/>
<ToReceivableLink
  viewPath={`${viewPath}/ToReceivableLink`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'on '"
 data="entry.created_at"
 format="/Data/format.js dateShortWithMonthAndTime"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
<div
  data-testid="TransferCharge.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-8-cMlrT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2ReturnIcon
  viewPath={`${viewPath}/Tysiav2ReturnIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text="Transferred from"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text={aggregateData1 ? "existing payor" : "different payor"}
 data="entry.transaction.receivable.payment_account.id"
 data="entry.transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable.payment_account.id"
 aggregate="/Data/aggregate.js equals"
/>
<LedgerPaymentAccount
  viewPath={`${viewPath}/LedgerPaymentAccount`}
 data="entry.transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable.payment_account"
 value={entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivablePaymentAccountValueData}
 onClick={onClick}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}